module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82fa0d66d5e20320021f46d36003dda5.png";